<template>
    <div class="auth-details fff">
        <div class="auth-management-top mb20">
            <div>
                <span class="cur" @click="backDetails"><i class="el-icon-arrow-left"></i>返回</span>
                <el-divider direction="vertical" class="color999"></el-divider>
                <span class="color999 cur" @click="back">角色权限管理&nbsp;/&nbsp;</span>
                <span class="color999 cur">角色编辑&nbsp;&nbsp;</span>
            </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleChanges">
            <el-tab-pane v-for="(item, index) in tab" :key="index" :label="item.title" :name="index + ''"></el-tab-pane>
        </el-tabs>
        <!-- 按钮 -->
        <div class="btn-group mb20" style="justify-content: space-between;">
            <div>角色名称：{{ roleName }}</div>
            <div style="display: flex; align-items: center;">
                <div v-show="activeName == '0' && systemTag == 'no' && !authShow">
                    <el-button type="default" size="small" @click="cancel('1')">取消</el-button>
                    <el-button type="primary" size="small" class="resetbgc" @click="save('1')">保存</el-button>
                </div>
                <div v-show="activeName == '1' && !appShow">
                    <el-button type="default" size="small" @click="cancel('2')">取消</el-button>
                    <el-button type="primary" size="small" class="resetbgc" @click="save('2')">保存</el-button>
                </div>
                <!-- 选择全部权限 -->
                <div style="position: relative;width: 120px;height: 50px;" v-if="activeName == '0' && !authShow">
                    <el-button :type="allFlag ? 'default' : 'primary'" size="small" :class="[!allFlag ? 'resetbgc' : 'view']"
                        style="position: absolute;right: 0;top: 5px;" @click="allAuth">{{
                            allFlag ? '取消全部权限' : '选择全部权限' }}</el-button>
                </div>
                <div class="update-btn">
                    <el-button type="primary" class="resetbgc" v-if="authShow && activeName == '0'" size="small"
                        @click="showUpdate('1')">编辑</el-button>
                    <el-button type="primary" class="resetbgc" v-if="appShow && activeName == '1'" size="small"
                        @click="showUpdate('2')">编辑</el-button>
                </div>
            </div>
        </div>

        <!-- 权限详情 -->
        <div class="auth-detail" v-if="activeName == '0'">
            <div class="nav-top">
                <div class="item">序号</div>
                <div class="item">模块</div>
                <div class="item">功能</div>
                <div class="item">授权</div>
                <div class="item" style="margin-right: 0;">全选</div>
            </div>
            <div class="content" style="max-height: 570px;overflow-y: auto;">
                <div v-for="item, index in menuList" :key="index" style="border-bottom: 1px solid #000;display: flex;"
                    class="">
                    <div
                        style="margin-right: 200px;min-width: 100px!important;display: flex;align-items: center;padding-left: 5px;">
                        {{ index
                            + 1
                        }}</div>
                    <div style="margin-right: 200px;min-width: 100px;display: flex;align-items: center;">{{ item.name }}
                    </div>
                    <div>
                        <div v-for="i, d in item.nextMenuList" :key="d"
                            style="display: flex;margin-bottom: 20px;align-items: center;">
                            <div style="min-width: 100px;margin-right: 200px;display: flex;">{{ i.name }}</div>
                            <div
                                style="display: flex;min-width: 250px;max-width:250px;flex-wrap: wrap;flex-direction: row;margin-right: 50px;">
                                <div v-for="c, z in i.nextMenuList" :key="z" style="margin-bottom: 10px;margin-right: 5px;">
                                    <span v-if="!(c.dataPermList.length > 0)" style="margin-right: 10px;">
                                        <el-checkbox v-model="c.selectFlag" :disabled="systemTag == 'yes'"
                                            @change="changeCheckbox($event, c, i)"></el-checkbox> {{ c.name }}</span>
                                    <span v-else>
                                        <el-checkbox v-model="c.selectFlag" @change="doCheck($event, c, i)"></el-checkbox>
                                        {{
                                            c.name }}
                                        <div v-if="c.selectFlag"
                                            style="background: rgb(242, 242, 242);padding-top: 10px;max-width:200px ;">
                                            <el-radio-group v-for="radio, radioIndex in c.dataPermList" :key="radioIndex"
                                                v-model="radio[0].showId" @change="changeRadio($event, radio)"
                                                style="margin-bottom: 5px;">
                                                <el-radio :label="it.id" v-for="it, itIndex in radio" :key="itIndex">{{
                                                    it.name }}</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div style="min-width: 100px;display: flex;">
                                <el-switch v-model="i.selectFlag" active-color="#13ce66" inactive-color="#DCDCDC"
                                    @change="allChoose($event, i, item.nextMenuList[d])">
                                </el-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeName == '1'" style="height: 650px;overflow-y: auto;width: 99%;">
            <el-table :data="appList" @selection-change="selectChange" ref="multipleTable" border>
                <el-table-column type="selection" width="50" v-if="!appShow" />
                <el-table-column label="姓名" prop="staffName" width="400"></el-table-column>
                <el-table-column label="手机号码" prop="mobile" width="auto"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tab: [{ title: '权限详情' }, { title: '应用账号' }],
            activeName: '0',
            menuList: [],
            roleName: '',
            appList: [],
            menuIdList: [], // 权限(菜单ID)数组
            dataPermIdList: [], // 数据权限(菜单ID)数组
            systemTag: '',
            id: '',
            allFlag: false,
            authShow: false, // false 不显示编辑按钮 true 显示编辑按钮
            appShow: false,  // false 不显示编辑按钮 true 显示编辑按钮
            selectionKeys: []
        }
    },
    created() {
        // this.init()
        // this.getAppList()
        this.systemTag = this.$route.query.systemTag
        this.activeName = this.$route.query.activeName
        this.id = this.$route.query.id
    },
    mounted() {
        if (this.$route.query.type == 'auth') {
            this.authShow = false
            this.appShow = true
        } else if (this.$route.query.type == 'app') {
            this.authShow = true
            this.appShow = false
        }
        this.init()
        this.getAppList()
    },
    methods: {
        setKeys() {
            this.selectionKeys.map(key => {
                this.appList.map(row => {
                    if (row.staffId == key) {
                        console.log('row');
                        console.log(row);
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    }
                })
            })
        },
        showUpdate(option) {
            if (option == '1') {
                this.authShow = false
            }
            else {
                this.appShow = false
                this.getAppList()
            }
        },
        // 全部权限
        allAuth() {
            this.allFlag = !this.allFlag
            if (this.allFlag) {
                this.menuList.map(parent => {
                    parent.nextMenuList.map(children => {
                        // console.log(children);
                        children.nextMenuList.map(auth => {
                            children.selectFlag = true
                            auth.selectFlag = true
                            if (!(this.menuIdList.includes(auth.id))) {
                                this.menuIdList.push(auth.id)
                            }
                            if (!(children.seleArr.includes(auth.id))) {
                                children.seleArr.push(auth.id)
                            }
                            if (auth.dataPermList.length > 0) {
                                auth.dataPermList.map(data => {
                                    data[0].showId = data[0].id
                                    data[0].oldShowId = data[0].showId
                                    if (!(this.dataPermIdList.includes(data[0].showId))) {
                                        this.dataPermIdList.push(data[0].showId)
                                    }
                                })
                            }
                        })
                        children.isCount = children.seleArr.length
                        // console.log(children.name + '----' + children.isCount);
                    })
                })
            } else {
                this.menuList.map(parent => {
                    parent.nextMenuList.map(children => {
                        children.nextMenuList.map(auth => {
                            children.selectFlag = false
                            auth.selectFlag = false
                            let index = this.menuIdList.indexOf(auth.id)
                            this.menuIdList.splice(index, 1)

                            let idx = children.seleArr.indexOf(auth.id)
                            children.seleArr.splice(idx, 1)

                            if (auth.dataPermList.length > 0) {
                                auth.dataPermList.map(data => {
                                    let index = this.dataPermIdList.indexOf(data.id)
                                    this.dataPermIdList.splice(index, 1)
                                })
                            }
                        })
                        children.isCount = children.seleArr.length
                        // console.log(children.name + '----' + children.isCount);
                    })
                })
            }
            // console.log(this.menuIdList);
            // console.log(this.dataPermIdList);
        },
        allChoose(flag, row, itemBox) {
            console.log(itemBox);
            // console.log(itemBox.seleArr);
            if (flag) {
                row.nextMenuList.map(item => {
                    if (!(itemBox.seleArr.includes(item.id))) {
                        itemBox.seleArr.push(item.id)
                        itemBox.isCount = itemBox.seleArr.length
                    }
                    if (!(this.menuIdList.includes(item.id))) {
                        this.menuIdList.push(item.id)
                    }
                    if (item.dataPermList.length > 0) {
                        item.dataPermList.map(data => {
                            data[0].oldShowId = data[0].showId
                            data[0].showId = data[0].id
                            if (!(this.dataPermIdList.includes(data[0].showId))) {
                                this.dataPermIdList.push(data[0].showId)
                            }
                        })
                    }
                    item.selectFlag = true
                    console.log(itemBox.isCount);
                    console.log(itemBox.seleArr);

                })
                // console.log(this.menuIdList);
                // console.log(this.dataPermIdList);
            } else {
                itemBox.seleArr = []
                itemBox.isCount = 0
                console.log(row.nextMenuList);
                row.nextMenuList.map(item => {
                    console.log(item);
                    let index = this.menuIdList.indexOf(item.id)
                    this.menuIdList.splice(index, 1)

                    let idx = itemBox.seleArr.indexOf(item.id)
                    itemBox.seleArr.splice(idx, 1)
                    item.selectFlag = false

                    if (item.dataPermList.length > 0) {
                        item.dataPermList.map(data => {
                            let index = this.dataPermIdList.indexOf(data.id)
                            this.dataPermIdList.splice(index, 1)
                        })
                    }
                    itemBox.isCount = itemBox.seleArr.length
                })
                // console.log(this.menuIdList);
                // console.log(this.dataPermIdList);
                console.log(itemBox.isCount);
                console.log(itemBox.seleArr);
            }
        },
        changeCheckbox(flag, button, item) {
            let length = item.nextMenuList.length
            if (flag && !(this.menuIdList.includes(button.id))) {
                this.menuIdList.push(button.id)
                item.isCount++
                item.selectFlag = length === item.isCount
            } else {
                let index = this.menuIdList.indexOf(button.id)
                this.menuIdList.splice(index, 1)
                item.isCount--
                item.selectFlag = length === item.isCount
            }
        },
        async init() {
            const res = await this.$api.post(this.$url.auth.edtiList, { roleId: this.$route.query.id })
            this.roleName = res.roleName
            this.menuList = res.menuVOList
            let authList = []
            res.menuVOList.map(v => {
                v.nextMenuList.map(h => {
                    this.$set(h, 'isCount', 0)
                    this.$set(h, 'seleArr', [])
                    h.nextMenuList.map(j => {
                        authList.push(j)
                        if (j.selectFlag) {
                            this.menuIdList.push(j.id)
                            h.seleArr.push(j.id)
                            // console.log(j);
                            h.isCount = h.seleArr.length
                            // console.log(h.name + ' - ' + h.isCount);
                        }
                        if (j.dataPermList.length > 0) {
                            j.dataPermList.map(data => {
                                data.forEach((dataItem, dataIndex) => {
                                    if (dataItem.showId != '') {
                                        this.dataPermIdList.push(dataItem.showId)
                                        data[0].oldShowId = data[0].showId
                                        data[0].showId = dataItem.showId
                                    }
                                })
                            })
                        }
                    })
                })
            })
            this.allFlag = this.menuIdList.length == authList.length
            // console.log(this.menuIdList);
            // console.log(this.dataPermIdList);
        },
        async getAppList() {
            const res = await this.$api.post(this.$url.auth.appList, { roleId: this.$route.query.id })
            this.appList = res
            res.map(item => {
                if (item.selectFlag) {
                    if (!this.selectionKeys.includes(item.staffId)) this.selectionKeys.push(item.staffId)
                }
            })
            this.$nextTick(() => {
                this.setKeys()
            });
        },
        handleChanges() {
            if (this.activeName == '0') {
                this.init()
            } else if (this.activeName == '1') {
                this.getAppList()
                this.$nextTick(() => {
                    this.setKeys()
                });
            }
        },
        update() {

        },
        cancel(option) {
            this.$router.push({
                path: '/dataList/authDetails',
                query: { id: this.$route.query.id, systemTag: this.systemTag, activeName: this.activeName }
            })
        },
        async save(option) {
            if (option == '1') {
                const res = await this.$api.post(this.$url.auth.saveAuth,
                    {
                        id: this.$route.query.id,
                        // roleName: this.roleName,
                        roleName: this.$route.query.roleName,
                        menuIdList: this.menuIdList,
                        dataPermIdList: this.dataPermIdList
                    })
                if (res) {
                    this.$message.success('保存成功')
                    this.$router.push({
                        path: '/dataList/authDetails',
                        query: { id: this.$route.query.id, systemTag: this.systemTag, activeName: this.activeName }
                    })
                }
            } else {
                const res = await this.$api.post(this.$url.auth.appSave,
                    {
                        roleId: this.$route.query.id,
                        roleName: this.roleName,
                        staffIdList: this.selectionKeys
                    })
                if (res) {
                    this.$message.success('保存成功')
                    this.$router.push({
                        path: '/dataList/authDetails',
                        query: { id: this.$route.query.id, systemTag: this.systemTag, activeName: this.activeName }
                    })
                    this.$refs.multipleTable.clearSelection();
                }
            }
        },
        //选择某一个单元
        doCheck(flag, button, item) {
            console.log(button);
            console.log(item);
            let length = item.nextMenuList.length
            if (flag) {
                item.isCount++
                item.selectFlag = length === item.isCount
                console.log(item.selectFlag);
                if (!(this.menuIdList.includes(button.id))) {
                    this.menuIdList.push(button.id)
                }
                button.dataPermList.map(item => {
                    item[0].showId = item[0].id
                    item[0].oldShowId = item[0].showId
                    if (!(this.dataPermIdList.includes(item[0].showId))) {
                        this.dataPermIdList.push(item[0].showId)
                    }
                })
            } else {
                item.isCount--
                item.selectFlag = length === item.isCount
                let index = this.menuIdList.indexOf(button.id)
                this.menuIdList.splice(index, 1)
                button.dataPermList.map(item => {
                    let index = this.dataPermIdList.indexOf(item[0].showId)
                    if (index != -1) this.dataPermIdList.splice(index, 1)
                    item[0].showId = ''
                })
            }
        },
        changeRadio(val, radio) {
            console.log(radio[0].oldShowId);
            console.log(val);
            let index = this.dataPermIdList.indexOf(radio[0].oldShowId)
            if (index != -1) this.dataPermIdList.splice(index, 1)
            if (!(this.dataPermIdList.includes(val))) this.dataPermIdList.push(val)
            radio[0].oldShowId = val
            // console.log(this.menuIdList);
            console.log(this.dataPermIdList);
        },
        selectChange(rows) {
            this.selectionKeys = rows.map(item => item.staffId);
            console.log(this.selectionKeys);
        },
        backDetails() {
            this.$router.push({
                path: '/dataList/authDetails',
                query: { id: this.id, systemTag: this.systemTag, activeName: this.activeName }
            });
        },
        back() {
            this.$router.push("/dataList/authManagement");
        }
    }
}
</script>

<style scoped lang="less">
.auth-details {
    padding: 25px;
}

.el-button.resetbgc {
    background: rgb(32, 107, 248)
}

.auth-list {
    display: flex;
    flex-wrap: wrap;
}

.nav-top {
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
    background-color: rgb(242, 242, 242);
    padding-left: 5px;

    .item {
        min-width: 100px;
        margin-right: 200px;
    }
}

.wrapper {
    background-color: #fff !important;
}

.btn-group {
    display: flex;
    align-items: center;
    // height: 50px;
    justify-content: flex-end;
}
.view:focus{
    border: 1px solid #dcdfe6;
    background: #fff;
    cursor: pointer;
    color: #606266;
}
</style>